import { ResultsFilters } from './types.ts';

export const initialFilters: ResultsFilters = {
  collectionDate: null,
  physician: null,
  healthCase: [],
  sort: { field: '', desc: true },
};
